'use strict';
import Splide from '@splidejs/splide';

const initMagazineKvSplide = () => {
  const magazineIndexKvSplideOptions = {
    mediaQuery: 'min',
    type: 'loop',
    perMove: 1,
    autoplay: false,
    focus: 'center',
    arrows: true,
    drag: false,
    gap: '1em',
    padding: '2em',
    speed: 1000,
    clones: 2,
    snap: true,
    direction: 'rtl',
    breakpoints: {
      750: {
        gap: '3em',
        padding: '30em',
      },
    },
  };
  const magazineIndexSplide = new Splide(
    '.magazine-kv-slide__list',
    magazineIndexKvSplideOptions
  );
  magazineIndexSplide.mount();
};
const initMagazineSplide = () => {
  const magazineIndexSplideOptions = {
    mediaQuery: 'min',
    type: 'loop',
    // rewind: true,
    perMove: 1,
    perPage: 1.6,
    autoplay: false,
    // focus: 'center',
    arrows: true,
    drag: true,
    gap: '2em',
    pagination: false,
    speed: 1000,
    clones: 0,
    snap: true,
    completely: false,
    breakpoints: {
      960: {
        destroy: true,
      },
    },
  };
  const Slides = document.querySelectorAll('.magazine-index-slide');
  let splide;
  Slides.forEach((slide) => {
    splide = new Splide(slide, magazineIndexSplideOptions);
    splide.mount();
  });
};

const searchFormAddPlaceholder = () => {
  const searchForms = document.querySelectorAll('input[name="s_keyword_0"]');
  searchForms.forEach((searchForm) => {
    searchForm.placeholder = 'キーワードを入力してください';
  });
};

window.addEventListener('DOMContentLoaded', () => {
  initMagazineKvSplide();
  initMagazineSplide();
  searchFormAddPlaceholder();
});
